import { render, staticRenderFns } from "./remove-quotation-request-confirm.vue?vue&type=template&id=028b35b0&"
import script from "./remove-quotation-request-confirm.vue?vue&type=script&lang=js&"
export * from "./remove-quotation-request-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports